export default "__VITE_ASSET__9d81e9ef__"